import { Reveal } from "@/components/Reveal";

const PARTNERS = ["Oracle", "SAP", "Salesforce", "AWS", "Microsoft Azure", "ServiceNow", "Snowflake", "Google Cloud", "Workday"];

const Item = ({ name }) => (
  <div className="flex items-center gap-16 md:gap-24 shrink-0">
    <span className="font-heading font-bold text-2xl md:text-[1.7rem] tracking-tight text-brand-ink/75 hover:text-brand-primary/85 transition-colors duration-300 whitespace-nowrap">
      {name}
    </span>
    <span className="h-1.5 w-1.5 rounded-full bg-brand-magenta/60 shrink-0" aria-hidden="true" />
  </div>
);

export const PartnersStrip = () => (
  <section className="bg-white border-y border-brand-ink/10 py-12 md:py-16 overflow-hidden" data-testid="partners-strip">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <Reveal>
        <p className="text-center text-xs md:text-sm tracking-[0.35em] text-brand-ink/70 uppercase">
          Technologies &amp; platforms we work across
        </p>
      </Reveal>
    </div>
    <div
      className="relative mt-9 overflow-hidden"
      style={{ maskImage: "linear-gradient(to right, transparent, black 8%, black 92%, transparent)", WebkitMaskImage: "linear-gradient(to right, transparent, black 8%, black 92%, transparent)" }}
    >
      <div className="partners-track flex w-max items-center gap-16 md:gap-24 pr-16 md:pr-24">
        {[...PARTNERS, ...PARTNERS].map((name, i) => (
          <Item key={`${name}-${i}`} name={name} />
        ))}
      </div>
    </div>
  </section>
);
